import { post, get, put, del as requestDel } from '@/utils/request';

// 新增/修改设备台账
export function EquipmentLedgerAdd(Data) {
  if (Data.id && Data.id > 0) {
    return put('/api/v1/equipment-ledger/' + Data.id, Data);
  }
  return post('/api/v1/equipment-ledger', Data); 
}

// 设备台账列表
export function EquipmentLedgerList(Data) {
  return get('/api/v1/equipment-ledger/page', Data); 
}

// 设备台账删除
export function EquipmentLedgerDel(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return requestDel('/api/v1/equipment-ledger/' + id); 
}

// 设备台账详情
export function EquipmentLedgerDetail(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return get('/api/v1/equipment-ledger/detail', { id }); 
}

// 首页统计卡片数据
export function EquipmentLedgerHomeStats() {
  return get('/api/v1/equipment-ledger/home-stats');
}

// 首页作业趋势折线图数据
export function EquipmentLedgerHomeTrends(range) {
  return get('/api/v1/equipment-ledger/home-trends', { range });
}
